import React, {
  forwardRef,
  Ref,
  useId,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';

// Types
import { InputExpedientProps, ImperativeRefInputExpedient } from './types';

// Components Styled
import { Container, InputValue, Label } from './styles';

// Media
import { useIsLandscapeTablet } from '../../../hooks/useMediaBreakPoints';
import isEqual from 'lodash.isequal';

/**
 * Primary UI component for expedient filtering
 */
function InputExpedient(
  {
    label = 'Expedient',
    disabled,
    onChangeInputExpedient,
    expedient,
    ...props
  }: InputExpedientProps,
  innerRef: Ref<ImperativeRefInputExpedient>
): JSX.Element {
  const [inputValue, setInputValue] = useState<string>(
    expedient !== undefined ? expedient.toString() : ''
  );

  const onChangeInput = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;

      // Solo permitir números
      if (value === '' || /^\d+$/.test(value)) {
        setInputValue(value);
        const numericValue = value === '' ? undefined : parseInt(value, 10);
        onChangeInputExpedient(numericValue);
      }
    },
    [onChangeInputExpedient]
  );

  useImperativeHandle(innerRef, () => ({
    clearSelected: () => {
      setInputValue('');
      onChangeInputExpedient(undefined);
    },
  }));

  const id = useId();
  const isLandscapeTablet = useIsLandscapeTablet();

  return (
    <Container {...props}>
      {label && (
        <Label
          component={'label'}
          htmlFor={`${id}-expedient-input`}
          colorText="black"
          size={isLandscapeTablet ? 'XS' : 'S'}
        >
          {label}
        </Label>
      )}
      <InputValue
        id={`${id}-expedient-input`}
        type="text"
        disabled={disabled}
        maxLength={7}
        placeholder={'0000000'}
        value={inputValue}
        onChange={onChangeInput}
        onKeyDown={(e) => {
          // Prevenir caracteres especiales
          /[+*./,\\-]/.test(e.key) && e.preventDefault();
        }}
      />
    </Container>
  );
}

export default React.memo(forwardRef(InputExpedient), isEqual);
